import * as React from 'react';
import { useParams } from 'react-router-dom';

import '../index.scss';
import './index.scss';

import AppLayout from '../../layouts/app/AppLayout';
import HeaderRightUserInfo from '../../components/headerRightUserInfo';
import PdfReportList from './list';
import AddEditPdfReport from './addEdit';



export default function PdfReportSection() {
    const pageName = "PDF reports";
    const { page = 'list' } = useParams()

    const getSelectedContent = () => {
        const selectedItem = page;
        let contentSelected = <PdfReportList />
        switch (selectedItem) {
            case 'list':
                contentSelected = <PdfReportList />;
                break;
            case 'view':
                contentSelected = <AddEditPdfReport />;
                break;
            case 'add':
                contentSelected = <AddEditPdfReport />;
                break;
            case 'edit':
                contentSelected = <AddEditPdfReport />;
                break;
            default:
                contentSelected = <span>Not found</span>;
                break;
        }
        return contentSelected;
    }



    return (
        <>
            <AppLayout
                pageName={pageName}
            >
                <div className="main-content-wrapper news-main-wrapper f-wrp">
                    <div className='panel-main-header f-wrp'>
                        <h1>{'PDF Reports'}</h1>
                        <HeaderRightUserInfo />
                    </div>
                    <div className="main-container-wrp">
                        {getSelectedContent()}
                    </div>
                </div>
            </AppLayout >
        </>
    );
}